import { DatePipe, NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { OtaInfoComponent } from '../ota-info/ota-info.component';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';
import { SharedValidators } from '../shared/validators/shared-validators';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-manual-ota',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    NgxPaginationModule,
    DatePipe,
    CommonPaginationComponent,
    MatError,
    MatFormField,
    MatLabel,
    MatInput,
    CommonDropdownSearchComponent,
    CommonSearchComponent,
    MatCheckbox,
    NgClass,
    MatTooltip,
    OtaInfoComponent,
  ],
  templateUrl: './manual-ota.component.html',
  styleUrl: './manual-ota.component.scss',
})
export class DeviceManualOtaComponent implements OnInit {
  page = 1;
  size = 10;
  totalLength = 0;
  search = '';
  deviceList = [];
  exportData: {
    'Batch Id': string;
    IMEI: string;
    'OTA Command': string;
    'OTA Response': string;
    'OTA Status': string;
    'Updated Date': string;
  }[] = [];

  deviceOTAForm: FormGroup = this.formBuilder.group({});
  filterForm: FormGroup = this.formBuilder.group({});
  CommandForm: FormGroup = this.formBuilder.group({});

  userPermission = [];

  imei = '';

  manualOtaToggle = false;

  searchParam = '';
  filterSelect = '';
  allSelected = false;
  config = false;

  isSearched = false;
  createManualOta = false;
  deleteManualOta = false;
  deleteOta = false;

  paraArr: {
    otaCommand: string;
    name: string;
    example: string;
    id: string;
    time: string;
    isInputRequired: boolean;
  }[] = [];

  // Set Configuration Value
  otaListSelected: {
    otaCommand: string;
    name: string;
    example: string;
    id: string;
    time: string;
    isInputRequired: boolean;
  }[] = [];

  checkedArr: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    otaType: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  filteredSetCommandList: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    otaType: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  commandArray: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    otaType: string;
    timeInMs: string;
    isInputRequired: boolean;
  }[] = [];

  otaOverviewFilter = [
    { key: 'All', value: 'All' },
    { key: 'GET', value: 'GET' },
    { key: 'SET', value: 'SET' },
    { key: 'CLR', value: 'CLR' },
  ];

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceOtaForm();
    if (sessionStorage.getItem('otaDeviceHistoryImei')) {
      this.imei = sessionStorage.getItem('otaDeviceHistoryImei') || '';
      this.deviceOTAForm?.get('imei')?.setValue(this.imei);
      this.search = this.deviceOTAForm?.get('imei')?.value;
      this.getOtaBatchDeviceDetails();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Manual OTA' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'Manual OTA' && element.create === true) {
          this.createManualOta = true;
        }
        if (element.pageName === 'Manual OTA' && element.delete === true) {
          this.deleteManualOta = true;
        }
        if (element.pageName === 'OTA Batch' && element.delete === true) {
          this.deleteOta = true;
        }
      }
    );
  }

  setDeviceOtaForm() {
    this.deviceOTAForm = this.formBuilder.group({
      imei: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        SharedValidators.exactLengthValidator(15),
        SharedValidators.numericValidator,
      ]),
    });
    this.filterForm = this.formBuilder.group({
      filterSelected: new FormControl(''),
    });
  }

  getOtaBatchDeviceDetails() {
    this.spinner.show();
    this.apiMicroservice.getOTADevicesHistory(this.search).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.isSearched = true;
          this.exportData = res.data || [];
          this.imei = res.deviceResult?.[0]?.imei || this.imei;
          this.deviceOTAForm.get('imei')?.setValue(this.imei);
          this.deviceList = res.data;
          this.totalLength = this.deviceList.length;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        } else {
          this.deviceList = [];
          this.exportData = [];
          this.isSearched = false;
          this.apiMicroservice.openSnackbar(
            res.message || 'Something went wrong'
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.deviceList = [];
        this.exportData = [];
        this.isSearched = false;
        this.apiMicroservice.openSnackbar(
          error?.error?.message || 'Something went wrong'
        );
      },
    });
  }

  setManualOta() {
    this.manualOtaToggle = true;
    this.fetchOtaMaster();
  }

  filterSelected(event: string) {
    this.filterSelect = event;
    // this.checkedArr = [];
    // this.allSelected = false;
    this.fetchOtaMaster();
  }

  fetchOtaMaster() {
    this.spinner.show();
    this.apiMicroservice
      .getOtaCommandList(1, 10000, this.searchParam, this.filterSelect)
      .subscribe({
        next: (res) => {
          this.commandArray = res.data;
          this.filteredSetCommandList = [...this.commandArray];
          this.spinner.hide();
        },

        error: (err) => {
          this.apiMicroservice.openSnackbar(err.message);
          this.commandArray = [];
          this.filteredSetCommandList = [];
          this.spinner.hide();
        },
      });
  }

  onSearchOtaCommandList(event: string) {
    this.searchParam = event;
    this.fetchOtaMaster();
  }

  addToCheckedArray(
    event: MatCheckboxChange,
    item: {
      otaCommand: string;
      name: string;
      example: string;
      _id: string;
      timeInMs: string;
      isInputRequired: boolean;
      otaType: string;
    }
  ) {
    if (event.checked) {
      this.checkedArr.push(item);
    } else {
      this.checkedArr = this.checkedArr.filter(
        (checkedItem) => checkedItem._id !== item._id
      );
    }
  }

  checkChecked(item: {
    otaCommand: string;
    name: string;
    example: string;
    _id: string;
    timeInMs: string;
    isInputRequired: boolean;
    otaType: string;
  }): boolean {
    for (const checkedItem of this.checkedArr) {
      if (item._id === checkedItem._id) {
        return true;
      }
    }
    return false;
  }

  toggleSelectAll() {
    this.allSelected = !this.allSelected;

    this.checkedArr = [];

    this.filteredSetCommandList.forEach((item) => {
      const controlName = 'command_' + item._id;

      if (this.allSelected) {
        this.checkedArr.push(item);

        if (item.isInputRequired) {
          this.CommandForm.get(controlName)?.enable();
        }
      } else {
        this.CommandForm.get(controlName)?.reset();
        this.CommandForm.get(controlName)?.disable();
      }
    });
  }

  SubmitCommandArray() {
    this.size = 10;
    this.page = 1;
    this.paraArr = [];
    this.checkedArr.forEach((element) => {
      this.paraArr.push({
        otaCommand: element.otaCommand,
        name: element.name,
        example: element.example,
        id: element._id,
        time: element.timeInMs,
        isInputRequired: element.isInputRequired,
      });
    });
    const formGroupObject: any = {};
    this.paraArr.forEach(
      (elm: {
        otaCommand: string;
        name: string;
        example: string;
        id: string;
        time: string;
        isInputRequired: boolean;
      }) => {
        // Create a disabled form control
        formGroupObject[elm.otaCommand] = new FormControl(
          {
            value: '',
            disabled: !elm.isInputRequired,
          },
          elm.isInputRequired ? [SharedValidators.requiredAndNoEmptySpaces] : []
        );
      }
    );
    this.CommandForm = this.formBuilder.group(formGroupObject);
    this.totalLength = this.paraArr.length;
    if (this.totalLength > 0) {
      this.config = true;
    }
    this.otaListSelected = this.getPaginatedItems();
  }

  submit() {
    this.CommandForm.enable();

    const CommandFormValid = this.CommandForm.valid;
    const CommandFormData = this.CommandForm.value;

    if (!window.confirm('Are you sure?')) {
      this.apiMicroservice.openSnackbar('Form submission cancelled.');
      this.SubmitCommandArray();
      return;
    }

    if (!CommandFormValid) {
      this.CommandForm.markAllAsTouched();
      this.apiMicroservice.openSnackbar(
        'Please give input to all selected commands to submit the batch.'
      );
      return;
    }
    const payload: {
      imei: string;
      commandArray: {
        _id: string;
        name: string;
        otaCommand: string;
        value: string;
        isInputRequired: boolean;
        otaType: string;
        timeInMs: string;
      }[];
      createdBy: string;
    } = {
      imei: this.imei,

      createdBy: this.apiMicroservice.decryptData(
        sessionStorage.getItem('userRefId') || ''
      ),

      commandArray: this.checkedArr.map((cmd) => ({
        _id: cmd._id,
        name: cmd.name,
        otaCommand: cmd.otaCommand,
        value: cmd.isInputRequired ? CommandFormData[cmd.otaCommand] || '' : '',
        isInputRequired: cmd.isInputRequired,
        otaType: cmd.otaType,
        timeInMs: cmd.timeInMs,
      })),
    };

    this.spinner.show();

    this.apiMicroservice.createManualOta(payload).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (res.status) {
          this.apiMicroservice.openSnackbar('Manual OTA Created Successfully');
          this.getOtaBatchDeviceDetails();
          this.manualOtaToggle = false;
          this.config = false;
          this.allSelected = false;
          this.checkedArr = [];
          this.paraArr = [];
          this.searchParam = '';
          this.filterSelect = '';
          this.otaListSelected = [];
          this.CommandForm.reset();
          this.commandArray = [];
          this.filteredSetCommandList = [];
        } else {
          this.apiMicroservice.openSnackbar(
            res.message || 'Failed to create Manual OTA'
          );
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        const errorMessage =
          ERROR.error?.message || 'Error creating Manual OTA';
        this.apiMicroservice.openSnackbar(errorMessage);
      },
    });
  }

  getPaginatedItems() {
    const startIndex = Number(this.page - 1) * Number(this.size);
    const endIndex = Number(startIndex) + Number(this.size);
    return this.paraArr.slice(Number(startIndex), Number(endIndex));
  }

  deleteCommand(id: string) {
    this.paraArr = this.paraArr.filter((item) => item.id !== id);
    this.checkedArr = this.checkedArr.filter((item) => item._id !== id);
    this.SubmitCommandArray();
    this.getPaginatedItems();
  }

  clearCommand(otaCommand: string | number) {
    this.CommandForm.controls[otaCommand].setValue('');
  }

  changePage(page: number) {
    if (page >= 1 && page <= Math.ceil(this.paraArr.length / this.size)) {
      this.page = page;
      this.otaListSelected = this.getPaginatedItems();
    }
  }

  changeSize(size: number) {
    this.size = size; // Update page size
    this.page = 1; // Reset to first page
    this.otaListSelected = this.getPaginatedItems(); // Refresh paginated items
  }

  onPageChange(event: number) {
    this.page = event;
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
  }

  onSearch(event: string) {
    if (event.length !== 15 || isNaN(parseInt(event))) {
      this.apiMicroservice.openSnackbar('Please enter valid IMEI');
      this.deviceOTAForm.get('imei')?.setValue(this.search);
    } else {
      this.page = 1;
      this.size = 10;
      this.search = event;
      this.imei = event;
      this.deviceOTAForm?.get('imei')?.setValue(this.search);
      sessionStorage.setItem('otaDeviceHistoryImei', event);
      this.getOtaBatchDeviceDetails();
      this.manualOtaToggle = false;
    }
  }

  deleteOtaBatchDetails(id: string) {
    if (confirm('Are you sure to Abort the device OTA?')) {
      const abortedBy = this.apiMicroservice.decryptData(
        sessionStorage.getItem('userRefId') || ''
      );
      this.apiMicroservice.deleteOtaBatchDevice(id, abortedBy).subscribe({
        next: (res) => {
          if (res.status) {
            this.apiMicroservice.openSnackbar('Device Aborted Successfully');
            this.ngOnInit();
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          const example = ERROR.error.message;
          this.apiMicroservice.openSnackbar(example);
          this.ngOnInit();
        },
      });
    }
  }

  exportToExcel() {
    if (confirm('Do you want to download this history details?')) {
      this.spinner.show();
      if (this.deviceList.length > 0) {
        const mergedDataArray = this.exportData.flatMap((item: any) => {
          const entries: {
            'Batch Id': string;
            IMEI: string;
            'OTA Command': string;
            'OTA Response': string;
            'OTA Status': string;
            'Updated Date': string;
          }[] = [];
          if (item?.otaCommands?.length > 0) {
            item.otaCommands.forEach(
              (command: {
                command: string;
                response: string;
                status: string;
                updatedAt: string;
              }) => {
                entries.push({
                  'Batch Id': item.batchId || '',
                  IMEI: item.imei || '',
                  'OTA Command': command.command || '',
                  'OTA Response': command.response || '',
                  'OTA Status': command.status || '',
                  'Updated Date': command.updatedAt
                    ? new Date(command.updatedAt).toLocaleString('en-GB', {
                        timeZone: 'Asia/Kolkata',
                        hour12: true,
                      })
                    : '',
                });
              }
            );
          }

          return entries;
        });
        // Set the processed data for export
        this.exportData = mergedDataArray;

        if (this.exportData.length > 0) {
          exportAsCsvFile(this.exportData, 'Device_OTA_History_' + this.imei);
        } else {
          this.apiMicroservice.openSnackbar('No Data Found');
        }

        this.spinner.hide();
      } else {
        this.apiMicroservice.openSnackbar('No Data Found');
        this.spinner.hide();
      }
    }
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
